module.exports = __webpack_public_path__ + "assets/img/arrow_back_24px.0d3afb3d.svg";